import { SecureResponseFile } from '../../components/AzureFilesUploader/types';
import {
  AnnouncementBaseRelation,
  AnnouncementFormFile,
  AnnouncementSelectOptionType,
} from './types';

export const convertToFormFile = (
  item: SecureResponseFile,
): AnnouncementFormFile => ({
  id: item.id,
  name: `${item.name}.${item.extension}`,
});

export const convertToSelectOption = (
  item?: AnnouncementBaseRelation | null,
): AnnouncementSelectOptionType | null =>
  item
    ? {
        value: item.id,
        label: item.name,
      }
    : null;
